import { pageId } from "@octopusdeploy/portal-routes";
class DashboardPageIds {
    root = pageId({ area: "Dashboard", id: "Dashboard", name: "Dashboard" });
    configure = pageId({ area: "Dashboard", id: "Dashboard.Configure", name: "Configure Dashboard" });
}
export default new DashboardPageIds();
